import { render, staticRenderFns } from "./ContentPreferences.vue?vue&type=template&id=20a5ebd9&"
import script from "./ContentPreferences.vue?vue&type=script&lang=js&"
export * from "./ContentPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports